import pluralize from 'pluralize'
import {SkeletonText} from '@primer/react/experimental'
import type {EditablePreview} from '../types'
import {useIsLoading} from '../contexts/IsLoadingContext'

export type PreviewsCountSummaryProps = {
  previews: EditablePreview[]
}

export function PreviewsCountSummary({previews}: PreviewsCountSummaryProps) {
  const isLoading = useIsLoading()
  const branchProtectionCount = previews?.length ?? 0
  const rulesetCount = previews?.reduce((acc, {rulesets}) => acc + rulesets.length, 0) ?? 0

  if (isLoading) {
    return <SkeletonText />
  }

  return (
    <span>
      {rulesetCount} {pluralize('ruleset', rulesetCount)}{' '}
      <span>
        will be created from {branchProtectionCount} branch protection {pluralize('rule', branchProtectionCount)}.
      </span>
    </span>
  )
}
